"use strict";
'use es6'; // ⚠️ Hello HubSpotters, Please don't import from this module. ☠️

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uniqueId = exports.last = exports.isNaN = exports.first = void 0;
var uniqueIdCounter = 0;
/** @returns {string} a unique id string with the given prefix */

var uniqueId = function uniqueId(prefix) {
  return "" + (prefix == null ? '' : prefix) + ++uniqueIdCounter;
};
/** @returns {boolean} whether the given value is the constant NaN */


exports.uniqueId = uniqueId;

var isNaN = function isNaN(value) {
  return typeof value === 'number' && value !== +value;
};
/** @returns {*} the first element of an Array or NodeList */


exports.isNaN = isNaN;

var first = function first(list) {
  return list == null || list.length === 0 ? undefined : list[0];
};
/** @returns {*} the last element of an Array or NodeList */


exports.first = first;

var last = function last(list) {
  return list == null || list.length === 0 ? undefined : list[list.length - 1];
};

exports.last = last;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/utils/underscore/index.js
// module id = 69
// module chunks = 5 6 7